<rt-collapsible-card
  [uniqKey]="jobSkillsUniqKey()"
  [hasBorder]="false"
  [hasHeaderHorizontalPadding]="false"
  [collapsed]="enforceSkillsCardCollapsed()"
  (collapseChanged)="onCollapse($event)"
  layout
  margin-top-small-x
>
  <div leftSlot>
    <rt-heading>
      {{ 'app.interview.summary.skills_summary.evaluations_per_skill' | translate }}
    </rt-heading>
  </div>

  <div collapsible>
    <div class="columns-container" margin-bottom-small-x>
      <div class="columns">
        <div>{{ 'app.interview.summary.skills_summary.columns.skill' | translate }}</div>
        <div>
          {{ 'app.interview.summary.skills_summary.columns.proficiency_level' | translate }}
        </div>
        <div>
          {{ 'app.interview.summary.skills_summary.columns.evaluation_details' | translate }}
        </div>
      </div>
    </div>

    <div layout-vertical>
      @for (jobSkill of jobSkillsDetails(); track jobSkill.id) {
        <rt-job-skill-summary
          [uniqKey]="jobSkillUniqKey(jobSkill.id)"
          [skill]="jobSkill"
          margin-bottom
        />
      }
    </div>
  </div>
</rt-collapsible-card>
